import gql from 'graphql-tag';

import { clientWeb } from '../graphqlAPI';

const RE_FETCH_EXPIRED_USER_TOKEN = gql`
  mutation Post{
    refetchUserToken{
        isValid
        token
        error
    }
}`;

const refetchUserToken = async () => {
  try {
    const result = await clientWeb.mutate({
      mutation: RE_FETCH_EXPIRED_USER_TOKEN,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { refetchUserToken: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: refetchUserToken Error: ${error}`);
    return null;
  }
};

export default refetchUserToken;
